import { render, staticRenderFns } from "./GlobalMessageNotification.vue?vue&type=template&id=2ab13e6c&scoped=true"
import script from "./GlobalMessageNotification.vue?vue&type=script&lang=js"
export * from "./GlobalMessageNotification.vue?vue&type=script&lang=js"
import style0 from "./GlobalMessageNotification.vue?vue&type=style&index=0&id=2ab13e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab13e6c",
  null
  
)

export default component.exports